import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}

export const PayAtTable = t.type({
  HostMode: t.string,
  HostURL: tOptional(t.string),
  MerchantPassword: tOptional(t.string),
  StoreNumber: tOptional(t.string),
  UserNumber: tOptional(t.string),
  ClientId: tOptional(t.string),
  ClientSecret: tOptional(t.string),
  TokenHostEndpoint: tOptional(t.string),
  TokenHostAudience: tOptional(t.string),
  PrintMerchantReceipt: t.boolean,
  EnableSplitPayment: t.boolean,
});
